import { createSelector } from "reselect";

const selectUser = (state) => state.user;

export const selectUserValue = createSelector(
    [selectUser],
    (user) => user
  );